import React from "react";

type SelectBodyTypeProps = {
  label: string;
  iconSrc: string | null;
  iconAlt: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  className?: string;
};

const SelectBodyType = ({
  label,
  iconSrc,
  iconAlt = "",
  onClick,
  className = "",
}: SelectBodyTypeProps) => {
  return (
    <button
      onClick={onClick}
      className={[
        "flex flex-col items-center justify-center gap-4",
        "md:max-w-75 w-full p-4 max-h-[170px]",
        "cursor-pointer rounded-[10px]",
        "bg-primary text-white hover:bg-[#000B54]",
        "text-[16px] font-bold transition-colors",
        className,
      ].join(" ")}
    >
      <span>{label}</span>

      {iconSrc && (
        <img
          src={iconSrc}
          alt={iconAlt || label}
          className="w-auto h-25 object-contain"
        />
      )}
    </button>
  );
};

export default SelectBodyType;
